import { render, staticRenderFns } from "./ImageFormatTabs.vue?vue&type=template&id=f1d2d594&scoped=true"
import script from "./ImageFormatTabs.vue?vue&type=script&lang=js"
export * from "./ImageFormatTabs.vue?vue&type=script&lang=js"
import style0 from "./ImageFormatTabs.vue?vue&type=style&index=0&id=f1d2d594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d2d594",
  null
  
)

export default component.exports